import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { isLocalPreview } from "./previewMode";
import { previewAuth, previewDb } from "./previewStore";

const firebaseConfig = {
  apiKey: "AIzaSyAd232GSevEeZ8yPWQrcYvQQMoYvMtGL9g",
  authDomain: "clockingsystem-e1a7f.firebaseapp.com", // 關鍵修復
  projectId: "clockingsystem-e1a7f",
  storageBucket: "clockingsystem-e1a7f.firebasestorage.app",
  messagingSenderId: "913979856404",
  appId: "1:913979856404:web:5469c53d5d1c94757bf901",
};

const app = isLocalPreview ? null : initializeApp(firebaseConfig);

export const auth = isLocalPreview ? previewAuth : getAuth(app);
export const db = isLocalPreview ? previewDb : getFirestore(app);
